import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import { Grid } from '@material-ui/core';
import DashboardSidePanel from '../common/dashboardSidePannel';
import ScrollableTabPanel from '../common/ScrollableTabPanel';
import ManageSubscription from './manageSubscription';
import '../../css/common.scss';
import '../../css/button.scss';
import '../../css/rightPanel.scss';

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandPanel: false,
    };
  }

  onExpandClick = () => {
    const { expandPanel } = this.state;
    this.setState({
      expandPanel: !expandPanel,
    });
  };

  render() {
    const { expandPanel } = this.state;
    const tabsData = [
      {
        tabName: 'Manage Subscription',
        // disabled: true,
        component: <ManageSubscription />,
      },
    ];
    return (
      <div>
        <section
          className={
            !expandPanel
              ? 'root panel mainPanel miniPanel'
              : 'root panel mainPanel miniPanel expandPanel'
          }
        >
          <Grid container>
            <DashboardSidePanel />
            <Grid item xs={12} sm={7} className="mapPanel">
              <button
                type="button"
                className="app-nav-action"
                onClick={this.onExpandClick}
              >
                <span className="app-nav-action__item" />
              </button>
              <ScrollableTabPanel
                tabsData={tabsData}
                customStyle="taggingTabPanel"
                // broadcastTabChange={this.broadcastTabChange}
              />
            </Grid>
          </Grid>
        </section>
      </div>
    );
  }
}

export default withRouter(
  connect(
    null,
    null,
  )(withCookies(Pricing)),
);
